<template>
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="700px">
      <v-card>
        <v-card-title
          class="grey lighten-2"
          primary-title
        >
          <span class="headline">{{quoteData.id ? 'Edit' : 'Create'}} Quote</span>
          <v-spacer></v-spacer>
          <v-icon @click="close">close</v-icon>
        </v-card-title>
        <v-card-text style="padding: 30px 50px 0;max-height:600px;overflow-y:auto">
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Sales Person : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-select
                v-model="quoteData.salePerson"
                :items="saleUsers"
                item-text="firstName"
                item-value="id"
                dense
                outlined
                @blur="$v.quoteData.salePerson.$touch()"
                :error-messages="salePersonErrors"
              ></v-select>
              <!-- <span class="custom-danger ma-0 pt-1" v-if="isInvalidLiveDate">Invalid Incurred Date</span>
              <span class="custom-danger ma-0 pt-1" v-if="!isInvalidLiveDate && !payout.live_date">This field is required</span> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Billing Name as per Xero : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-autocomplete
                v-model="quoteData.billingContact"
                :items="xeroContacts"
                item-text="Name"
                attach
                dense
                outlined
                return-object
              ></v-autocomplete>
              <!-- <span class="custom-danger ma-0 pt-1" v-if="isInvalidLiveDate">Invalid Incurred Date</span>
              <span class="custom-danger ma-0 pt-1" v-if="!isInvalidLiveDate && !payout.live_date">This field is required</span> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Quote No : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                prefix="IO-"
                v-model="quoteData.quoteNo"
                v-on="on"
                dense
                outlined
                @blur="$v.quoteData.quoteNo.$touch()"
                :error-messages="quoteNoErrors"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Linked IOs : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <div class="d-flex flex-row mb-2" v-for="(linkIO, index) in quoteData.linkedIOs" :key="index"> 
                <v-text-field
                  prefix="IO-"
                  v-model="quoteData.linkedIOs[index]"
                  v-on="on"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
                <v-btn
                  style="min-width:30px;height:36px;"
                  color="red"
                  small
                  @click="deleteLinkIO(index)"
                >
                  <v-icon x-small style="color:#fff">mdi-delete-outline</v-icon>
                </v-btn>
              </div>
              <v-btn
                class="mt-2 ml-0"
                color="warning"
                small
                @click="addLinkIO()"
              >
                <v-icon color="white" title="Add Invoice Sent" small>mdi-plus</v-icon> Add
              </v-btn>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Quote Acceptance Date (DD/MM/YYYY) : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                v-model="quoteData.acceptanceDate"
                v-on="on"
                dense
                outlined
                @input="changeQuoteDate"
                @keyup.enter="changeQuoteDate"
                @blur="$v.quoteData.acceptanceDate.$touch()"
                :error-messages="acceptanceDateErrors"
              ></v-text-field>
              <p class="custom-danger ma-0 pt-1" style="margin-top:-30px!important" v-if="isInvalidQuoteDate">Invalid Quote Date</p>
              <!-- <span class="text-danger ma-0 pt-1" v-if="!isInvalidQuoteDate && !quoteData.acceptanceDate">Required</span> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Currency : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-select
                v-model="quoteData.currency"
                :items="currencyLists"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="isOtherCurrency">
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Quote Amt FC : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.quoteAmtFC"
                @blur="calcExgAmt"
                placeholder=""
                prefix="$"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="isOtherCurrency">
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Est Exchange Rate : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.estExchangeRate"
                @blur="calcExgAmt"
                placeholder=""
                prefix="$"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="isOtherCurrency">
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Confirm Exchange Rate : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.confirmExchangeRate"
                @blur="calcExgAmt"
                placeholder=""
                prefix="$"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="isOtherCurrency">
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Display Rate : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-radio-group
                class="mt-0"
                v-model="quoteData.priceRdo"
                row
                @change="calcExgAmt"
              >
                <div>
                  <v-radio
                    class="pt-1"
                    label="Est Rate"
                    color="warning"
                    :value="1"
                  ></v-radio>
                </div>
                <div>
                  <v-radio
                    class="pt-1"
                    label="Confirm Rate"
                    color="warning"
                    :value="2"
                  ></v-radio>
                </div>
              </v-radio-group>
              <v-text-field
                type="number"
                v-model="calculatedRate"
                placeholder=""
                prefix="$"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Quote Amt (excl. GST) : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.quoteAmt"
                placeholder=""
                prefix="$"
                outlined
                dense
                @blur="$v.quoteData.quoteAmt.$touch()"
                :error-messages="quoteAmtErrors"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="quoteData.id">
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Invoice Created on Xero: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.invoiceCreated"
                placeholder=""
                prefix="$"
                outlined
                dense
                @change="changeInvoiceSent"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="quoteData.id">
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Invoice Sent: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <!-- <div class="d-flex flex-row" v-if="!quoteData.id">
                <v-text-field
                  type="number"
                  v-model="quoteData.invoiceSent"
                  placeholder=""
                  prefix="$"
                  outlined
                  dense
                  @change="changeInvoiceSent"
                  @blur="$v.quoteData.invoiceSent.$touch()"
                  :error-messages="invoiceSentErrors"
                ></v-text-field>
              </div> -->
              <div v-if="quoteData.activity && quoteData.activity.length">
                <div class="d-flex flex-row mb-2" v-for="(activity, index) of quoteData.activity" :key="index">
                  <v-text-field
                    type="number"
                    v-model="activity.amount"
                    placeholder=""
                    prefix="$"
                    outlined
                    disabled
                    dense
                    hide-details
                  ></v-text-field>
                </div>
              </div>
              <div class="mt-1" v-if="quoteData.id">
                <v-btn
                  class="btn-invoice-sent-edit ml-0"
                  color="warning"
                  small
                  @click="openInvoiceSentEditDialog"
                >
                  <v-icon color="white" title="Add Invoice Sent" small>mdi-plus</v-icon> Add
                </v-btn>
                <v-btn
                  class="btn-invoice-sent-edit"
                  color="warning"
                  small
                  @click="openInvoiceSentActivityDialog(quoteData.activity)"
                  v-if="quoteData.id"
                >
                  <v-icon color="white" title="View Details" small>remove_red_eye</v-icon> View
                </v-btn>
              </div>
              <!-- <p class="custom-danger" style="margin-top:-22px;" v-if="invalidInvoiceSent">Invoice Sent must be less than Quote Amount!</p> -->
            </v-col>
          </v-row>
          <v-row v-if="quoteData.id">
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Yet to Invoice: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.invoicePending"
                placeholder=""
                prefix="$"
                disabled
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <div style="width:100%">
            <v-divider></v-divider>
          </div> -->
          <!-- <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Prior {{currentYear}}: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.priorYear"
                placeholder=""
                prefix="$"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">For Year {{nextYear}}: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.nextYear"
                placeholder=""
                prefix="$"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Accrued Revenue: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.accruedRevenue"
                placeholder=""
                prefix="$"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label">Deferred Revenue: </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                type="number"
                v-model="quoteData.deferredRevenue"
                placeholder=""
                prefix="$"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row> -->
          <!-- <v-row v-if="quoteData.id">
            <v-col class="pb-0" cols="12" md="5" sm="12">
              <p class="title-1 form-label" style="font-size:14px">Indicate Cost (For Markup) : </p>
            </v-col>
            <v-col class="pb-0" cols="12" md="7" sm="12">
              <v-text-field
                v-model="quoteData.indicateCost"
                placeholder=""
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row v-if="quoteData.id">
            <h4 style="font-weight:bold;" class="pl-2 mb-0">Timelines</h4>
            <v-col class="pb-0" cols="12" md="12" sm="12">
              <v-btn
                class="ml-0"
                color="warning"
                small
                @click="openTimelineUpdateDialog"
              >
                <v-icon color="white" title="Add Invoice Sent" small>mdi-plus</v-icon> Add
              </v-btn>
            </v-col>
            <v-col class="pb-0" cols="12" md="12" sm="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Amount</th>
                      <th class="text-left">Start Month</th>
                      <th class="text-left">End Month</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Remark</th>
                      <th class="text-left">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="!quoteData.quoteData.length">
                      <td colspan="4">Empty List</td>
                    </tr>
                    <tr v-for="(item, index) in quoteData.quoteData" :key="index">
                      <td>${{ item.quoteAmt | thousandSeprator }}</td>
                      <td>{{ formatMonth(item.startMonth) }}</td>
                      <td>{{ formatMonth(item.endMonth) }}</td>
                      <td>
                        <span v-if="item.status === quoteStatuses.ACCEPT">Approved</span>
                        <span v-else-if="item.status === quoteStatuses.REJECT">Rejected</span>
                        <span v-else>Pending</span>
                      </td>
                      <td>{{ item.remarks || '' }}</td>
                      <td>
                        <div class="ma-1" v-if="item.status === quoteStatuses.ACCEPT">
                          <div>
                            <v-btn
                              class="ml-0"
                              color="warning"
                              small
                              @click="openTimelineUpdateDialogForEdit(item, index)"
                            >
                              <v-icon x-small>edit</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <div class="ma-1" v-if="item.status === quoteStatuses.ACCEPT">
                          <div>
                            <v-btn
                              class="ml-0"
                              color="red"
                              small
                              @click="deleteTimeline(index)"
                            >
                              <v-icon x-small style="color:#fff">mdi-delete-outline</v-icon>
                            </v-btn>
                          </div>
                        </div>
                        <div class="mt-2" v-if="item.status === quoteStatuses.PENDING">
                          <div>
                            <v-btn
                              style="width:80px"
                              class="ml-0"
                              color="green"
                              small
                              @click="processQuoteData(index, quoteStatuses.ACCEPT)"
                            >
                              Approve
                            </v-btn>
                          </div>
                          <div>
                            <v-btn
                              style="width:80px"
                              class="ml-0 mt-1"
                              color="red"
                              small
                              @click="processQuoteData(index, quoteStatuses.REJECT)"
                            >
                              Reject
                            </v-btn>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="green darken-1" :disabled="disableMasterLists || invalidInvoiceSent || isInvalidQuoteDate" text @click="saveQuote">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
    <invoice-sent-edit-modal
      v-model="invoiceSentEditDialog"
      :value="invoiceSentEditDialog"
      :data="quoteData"
      @created="updatedInvoiceSent"
    />
    <invoice-sent-activity-modal
      v-model="invoiceSentActivityDialog"
      :value="invoiceSentActivityDialog"
      :data="editActivityData"
      @updateActivityData="updateActivityData"
    />
    <timeline-amount-update-modal
      v-model="timelineUpdateDialog"
      :value="timelineUpdateDialog"
      :data="quoteData"
      :editTimelineData="editTimelineData"
      :editTimelineIdx="editTimelineIdx"
      @created="updateTimelineAmount"
    />
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import xeroAPIS from '../../Xero/XeroAPIs';
import Loading from 'vue-loading-overlay';
import InvoiceSentEditModal from './InvoiceSentEditModal';
import InvoiceSentActivityModal from './InvoiceSentActivityModal';
import TimelineAmountUpdateModal from './TimelineAmountUpdateModal';
import moment from 'moment';
import config from '@/config';
import MasterListsConfig from './config'
export default {
  name: 'CreateQuoteModal',
  components: {
    Loading,
    InvoiceSentEditModal,
    InvoiceSentActivityModal,
    TimelineAmountUpdateModal
  },
  mixins: [validationMixin],
  validations: function() {
    return this.rules
  },
  props: [
    'value',
    'saleUsers',
    'editData'
  ],
  data() {
    return {
      xeroContacts: [],
      quoteData: {
        acceptanceDate: '',
        salePerson: '',
        billingContact: '',
        quoteNo: '',
        quoteAmt: 0,
        quoteAmtFC: 0,
        estExchangeRate: 0,
        confirmExchangeRate: 0,
        priceRdo: 1,
        indicateCost: '',
        invoiceSent: 0,
        invoiceCreated: 0,
        invoicePending: 0,
        priorYear: 0,
        nextYear: 0,
        accruedRevenue: 0,
        deferredRevenue: 0,
        currency: 'SGD',
        quoteData: []
        // linkedIOs: ['']
      },
      isLoading: false,
      invoiceSentEditDialog: false,
      invoiceSentActivityDialog: false,
      timelineUpdateDialog: false,
      activityData: null,
      editActivityData: [],
      editTimelineData: null,
      editTimelineIdx: null,
      currencyLists: [
        'SGD',
        'USD',
        'RM',
        'JPY'
      ],
      isInvalidQuoteDate: false,
      quoteStatuses: MasterListsConfig.quoteStatuses,
      calculatedRate: 0
    }
  },
  computed: {
    ...mapState({
      savedMasterList: state => state.campaign.savedMasterList,
      masterListErr: state => state.campaign.masterListErr
    }),
    disableMasterLists() {
      return this.$v.quoteData.$invalid
    },
    invalidInvoiceSent() {
      return Number(this.quoteData.quoteAmt) < Number(this.quoteData.invoiceSent)
    },
    rules() {
      const validationRules = {
        quoteData: {
          acceptanceDate: {
            required
          },
          salePerson: {
            required
          },
          quoteNo: {
            required
          },
          quoteAmt: {
            required
          }
        }
      }
      return validationRules
    },
    currentYear() {
      return moment().format('YYYY')
    },
    nextYear() {
      return moment().add(1, 'years').format('YYYY')
    },
    isOtherCurrency() {
      if (this.quoteData.currency !== 'SGD') {
        return true
      }
      return false
    },
    acceptanceDateErrors() {
      const errors = [];
      if (!this.$v.quoteData.acceptanceDate.$dirty) return errors;
      !this.$v.quoteData.acceptanceDate.required && errors.push('This field is required.');
      return errors;
    },
    salePersonErrors() {
      const errors = [];
      if (!this.$v.quoteData.salePerson.$dirty) return errors;
      !this.$v.quoteData.salePerson.required && errors.push('This field is required.');
      return errors;
    },
    quoteNoErrors() {
      const errors = [];
      if (!this.$v.quoteData.quoteNo.$dirty) return errors;
      !this.$v.quoteData.quoteNo.required && errors.push('This field is required.');
      return errors;
    },
    quoteAmtErrors() {
      const errors = [];
      if (!this.$v.quoteData.quoteAmt.$dirty) return errors;
      !this.$v.quoteData.quoteAmt.required && errors.push('This field is required.');
      return errors;
    },
    invoiceSentErrors() {
      const errors = [];
      if (!this.$v.quoteData.invoiceSent.$dirty) return errors;
      !this.$v.quoteData.invoiceSent.required && errors.push('This field is required.');
      return errors;
    },
    invoiceCreatedErrors() {
      const errors = [];
      if (!this.$v.quoteData.invoiceCreated.$dirty) return errors;
      !this.$v.quoteData.invoiceCreated.required && errors.push('This field is required.');
      return errors;
    }
  },
  watch: {
    editData: async function (newValue) {
      if (!newValue) {
        delete this.quoteData.id
        this.resetQuoteData()
        return
      }
      this.quoteData.id = newValue.id
      this.quoteData.acceptanceDate = newValue.acceptanceDate
      this.quoteData.salePerson = newValue.salePerson
      this.quoteData.billingContact = newValue.billingContact
      this.quoteData.quoteNo = newValue.quoteNo.replace('IO-', '')
      this.quoteData.quoteAmt = newValue.quoteAmt
      this.quoteData.invoiceSent = newValue.invoiceSent || 0
      this.quoteData.invoiceCreated = newValue.invoiceCreated || 0
      this.quoteData.invoicePending = newValue.invoicePending
      // this.quoteData.priorYear = newValue.priorYear || 0
      // this.quoteData.nextYear = newValue.nextYear || 0
      // this.quoteData.accruedRevenue = newValue.accruedRevenue || 0
      // this.quoteData.deferredRevenue = newValue.deferredRevenue || 0
      this.quoteData.activity = newValue.activity || []
      this.quoteData.currency = newValue.currency || 'SGD'
      this.quoteData.confirmExchangeRate = newValue.confirmExchangeRate || 0
      this.quoteData.estExchangeRate = newValue.estExchangeRate || 0
      this.quoteData.quoteAmtFC = newValue.quoteAmtFC || 0
      this.quoteData.priceRdo = newValue.priceRdo || 1
      this.quoteData.quoteData = newValue.quoteData || []
      // this.quoteData.linkedIOs = newValue.linkedIOs || []
      this.calcExgAmt()
    }
  },
  async mounted() {
    this.fetchXeroContact();
  },
  methods: {
    async saveQuote() {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to save changes?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let saveData = []
          let quoteData = Object.assign({}, this.quoteData)
          quoteData.quoteNo = `IO-${quoteData.quoteNo}`
          quoteData.quoteAmt = Number(quoteData.quoteAmt)
          quoteData.invoiceSent = Number(quoteData.invoiceSent)
          quoteData.invoiceCreated = Number(quoteData.invoiceCreated)
          quoteData.quoteAmtFC = Number(quoteData.quoteAmtFC || 0)
          quoteData.confirmExchangeRate = Number(quoteData.confirmExchangeRate || 0)
          quoteData.estExchangeRate = Number(quoteData.estExchangeRate || 0)
          // quoteData.priorYear = Number(quoteData.priorYear)
          // quoteData.nextYear = Number(quoteData.nextYear)
          // quoteData.accruedRevenue = Number(quoteData.accruedRevenue || 0)
          // quoteData.deferredRevenue = Number(quoteData.deferredRevenue || 0)
          if (!quoteData.id) {
            quoteData.activeYear = [
              this.currentYear
            ]
            if (quoteData.invoiceSent) {
              quoteData.activity = [
                {
                  timestamp: moment().toISOString(),
                  amount: Number(quoteData.invoiceSent),
                  remarks: ''
                }
              ]
            }
          }
          if (quoteData.quoteAmt) {
            quoteData.invoicePending = Number((Number(quoteData.quoteAmt) - Number(quoteData.invoiceCreated)))
          }
          saveData.push(quoteData)
          // Submit request to save campaign data
          await this.$store.dispatch('campaign/saveCampaignMasterLists', {
            data: saveData
          })
          this.isLoading = false;
          if (!this.savedMasterList) {
            this.$swal({
              text: this.masterListErr ? this.masterListErr : 'Error Saving Quote Data.',
              type: 'error'
            });
            return
          }
          this.resetQuoteData()
          // Show success message
          this.$swal({
            text: 'Successfully saved.',
            type: 'success'
          });
          this.$emit('created')
          this.close()
        }
      })
    },
    async processQuoteData(index, status) {
      let totalAmt = 0
      for (let q of this.quoteData.quoteData) {
        totalAmt += Number(q.quoteAmt)
      }
      let aval = Number(this.quoteData.invoiceCreated) - Number(totalAmt)
      if (aval < 0) {
        this.$swal({
          text: 'Available Amount Not Enough.',
          type: 'error'
        });
        return false
      }
      let statusTxt = ''
      if (status === this.quoteStatuses.ACCEPT) {
        statusTxt = 'Approve'
        if (!this.checkQuoteAmt(index)) {
          return false
        }
      }
      if (status === this.quoteStatuses.REJECT) {
        statusTxt = 'Reject'
      }
      this.$swal({
        title: 'Double Check!',
        text: `Are you sure you want to ${statusTxt}?`,
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let saveData = []
          let saveObj = {
            id: this.quoteData.id
          }
          this.quoteData.quoteData[index].status = status
          // turned off adding to the Billed Amount
          // if (status === this.quoteStatuses.ACCEPT) {
          //   let quoteOne = this.quoteData.quoteData[index]
          //   this.quoteData.activity.push({
          //     timestamp: moment().toISOString(),
          //     amount: Number(quoteOne.quoteAmt),
          //     startMonth: quoteOne.startMonth,
          //     endMonth: quoteOne.endMonth,
          //     remarks: ''
          //   })
          //   let totalInvoiceSent = Number(quoteOne.quoteAmt) + (Number(this.quoteData.invoiceSent) + Number(this.quoteData.invoiceCreated))
          //   saveObj.invoiceSent = totalInvoiceSent
          // }
          saveObj.quoteData = this.quoteData.quoteData
          saveObj.activity = this.quoteData.activity
          saveData.push(saveObj)
          // Submit request to save campaign data
          await this.$store.dispatch('campaign/saveCampaignMasterLists', {
            data: saveData
          })
          this.isLoading = false;
          if (!this.savedMasterList) {
            this.$swal({
              text: 'Error Saving Quote Data.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully saved.',
            type: 'success'
          });
          this.$emit('created')
          this.close()
        }
      })
    },
    async updateActivityData(activity) {
      this.isLoading = true
      let saveData = []
      let saveObj = {
        id: this.quoteData.id
      }
      saveObj.activity = activity
      saveData.push(saveObj)
      // Submit request to save campaign data
      await this.$store.dispatch('campaign/saveCampaignMasterLists', {
        data: saveData
      })
      this.isLoading = false;
      if (!this.savedMasterList) {
        this.$swal({
          text: 'Error Saving Quote Data.',
          type: 'error'
        });
        return
      }
      // Show success message
      this.$swal({
        text: 'Successfully saved.',
        type: 'success'
      });
    },
    async fetchXeroContact() {
      try {
        const resp = await xeroAPIS.getXeroContacts();
        const respData = resp.data;
        const data = respData.data;
        this.xeroContacts = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    resetQuoteData() {
      this.quoteData = {
        acceptanceDate: '',
        salePerson: '',
        billingContact: '',
        quoteNo: '',
        quoteAmt: 0,
        indicateCost: '',
        invoiceSent: 0,
        invoiceCreated: 0,
        invoicePending: 0,
        currency: 'SGD',
        quoteData: []
        // linkedIOs: ['']
      }
    },
    changeInvoiceSent() {
      if (!isNaN(this.quoteData.quoteAmt) && !isNaN(this.quoteData.invoiceSent)) {
        if (this.quoteData.quoteAmt > 0) {
          this.quoteData.invoicePending = this.quoteData.quoteAmt - (this.quoteData.invoiceCreated ? Number(this.quoteData.invoiceCreated) : 0)
        }
      }
    },
    openInvoiceSentEditDialog() {
      this.invoiceSentEditDialog = true
    },
    openTimelineUpdateDialog() {
      this.editTimelineData = null
      this.editTimelineIdx = null
      this.timelineUpdateDialog = true
    },
    openTimelineUpdateDialogForEdit(item, idx) {
      this.editTimelineIdx = idx
      this.editTimelineData = Object.assign({}, item)
      this.timelineUpdateDialog = true
    },
    openInvoiceSentActivityDialog(activity) {
      this.editActivityData = []
      if (Array.isArray(activity)) {
        this.editActivityData = activity.map(act => {
          act.remarksEdit = false
          return act
        })
      }
      this.invoiceSentActivityDialog = true
    },
    updatedInvoiceSent(updateData) {
      this.quoteData.activity = updateData.activity
      this.quoteData.invoiceSent = updateData.invoiceSent
      this.quoteData.invoicePending = updateData.invoicePending
      this.$emit('created')
    },
    updateTimelineAmount(updateData) {
      this.quoteData.quoteData = updateData.quoteData
      this.$emit('created')
    },
    changeQuoteDate() {
      this.isInvalidQuoteDate = false
      if (this.quoteData.acceptanceDate && !this.isDateValid(this.quoteData.acceptanceDate)) {
        this.isInvalidQuoteDate = true
        return;
      }
    },
    isDateValid(givenDate) {
      if (!givenDate) return true
      let regex = config.regexPattern.date_format
      if (givenDate.match(regex)) return true
      return false
    },
    close() {
      this.$emit('input');
    },
    formatMonth(value) {
      return moment(value).format('MMM YYYY');
    },
    checkQuoteAmt(index) {
      // check if entered quote amounts larger than available quote amt
      let distributeAmt = 0
      let enteredQuoteAmt = 0
      if (Array.isArray(this.quoteData.quoteData)) {
        enteredQuoteAmt += Number(this.quoteData.quoteData[index].quoteAmt)
      }
      distributeAmt += Number(this.quoteData.invoiceCreated || 0)
      if (distributeAmt < enteredQuoteAmt) {
        this.$swal({
          text: 'Available Amount Not Enough.',
          type: 'error'
        });
        return false
      } else if (Number(this.quoteData.quoteAmt) < distributeAmt) {
        this.$swal({
          text: 'Quote Amount Exceeded.',
          type: 'error'
        });
        return false
      }
      return true
    },
    getApprovedQuotes(quoteData) {
      // filtered for approved quotes only
      if (Array.isArray(quoteData)) {
        return quoteData.filter(q => q.status === this.quoteStatuses.ACCEPT)
      }
      return false
    },
    async deleteTimeline(idx) {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to Delete?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let deletedData = Object.assign([], this.quoteData.quoteData)
          deletedData.splice(idx, 1)
          let saveData = []
          saveData.push({
            id: this.quoteData.id,
            quoteData: deletedData
          })
          // Submit request to save campaign data
          await this.$store.dispatch('campaign/saveCampaignMasterLists', {
            data: saveData
          })
          this.isLoading = false;
          if (!this.savedMasterList) {
            this.$swal({
              text: this.masterListErr ? this.masterListErr : 'Error Saving Quote Data.',
              type: 'error'
            });
            return
          }
          // Show success message
          this.$swal({
            text: 'Successfully deleted.',
            type: 'success'
          });
          this.$emit('created')
          this.quoteData.quoteData.splice(idx, 1)
        }
      })
    },
    calcExgAmt() {
      if (this.quoteData.priceRdo === 1) {
        if (this.quoteData.quoteAmtFC && this.quoteData.estExchangeRate) {
          this.calculatedRate = (this.quoteData.quoteAmtFC * this.quoteData.estExchangeRate).toFixed(0)
        }
      } else {
        if (this.quoteData.quoteAmtFC && this.quoteData.confirmExchangeRate) {
          this.calculatedRate = (this.quoteData.quoteAmtFC * this.quoteData.confirmExchangeRate).toFixed(0)
        }
      }
    },
    addLinkIO() {
      this.quoteData.linkedIOs.push('')
    },
    deleteLinkIO(idx) {
      this.quoteData.linkedIOs.splice(idx, 1)
    }
  }
}
</script>
<style scoped>
  .custom-danger {
    color: #ff5252 !important;
    font-size: 12px;
  }
  .form-label {
    margin-bottom: 0;
    font-size: 15px;
    font-weight: bold;
    padding-top: 0;
  }
  .btn-invoice-sent-edit {
    /* max-width: 35px!important;
    min-width: 35px!important; */
    min-height: 36px;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// CreateQuoteModal.vue?d2c61c06